<template>
  <div class="login-body" v-loading.fullscreen.lock="fullscreenLoading">
    <img
      src="../assets/images/img-Background.png"
      style="z-index:1;position:fixed;top:0;left:0;width:100%;height:100%"
    />
    <div class="app" style="z-index:2">
      <div class="top">
        <img src="../assets/images/img-logo.png" alt />
      </div>
      <div class="bodd">
        <div class="inp">
          <div>
            <img src="../assets/images/icon-zhanghu.png" alt />
          </div>
          <div>
            <el-input placeholder="请输入账号" v-model="formLabelAlign.loginId"></el-input>
          </div>
          <div></div>
        </div>
        <div class="inp">
          <div>
            <img src="../assets/images/icon-mima.png" alt />
          </div>
          <div>
            <el-input placeholder="请输入密码" :type="password" v-model="formLabelAlign.loginPwd"></el-input>
          </div>
          <div>
            <img
              @click="togg"
              v-show="!show"
              class="shou"
              src="../assets/images/icon-xianshi.png"
              alt
            />
            <img
              @click="togg"
              v-show="show"
              class="shou"
              src="../assets/images/icon-yincang.png"
              alt
            />
          </div>
        </div>
        <div class="inp">
          <div>
            <img src="../assets/images/icon-yanzheng.png" alt />
          </div>
          <div>
            <el-input
              @keyup.enter.native="login"
              placeholder="请输入验证码"
              type="text"
              v-model="captcha"
            ></el-input>
          </div>
          <div>
            <img :src="vaite" @click="clickVaite" title="点击获取验证码" alt />
          </div>
          <div style="width:100px;"></div>
        </div>
      </div>
      <div class="action">
        <span style="cursor:pointer;" @click="forgotpass">忘记密码？</span>
      </div>
      <el-button
        style="width:100%;margin-top:20px;backgorund-color:#64caff;font-size:20px"
        type="primary"
        @click="login"
      >登 录</el-button>

      <el-dialog
        :append-to-body="true"
        title="找回密码"
        :visible.sync="changepass"
        width="400px"
        height="400px"
      >
        <el-form
          v-if="changepass"
          :label-position="left"
          :inline="true"
          size="mini"
          label-width="80px"
          :model="formInlinezin"
          class="demo-form-inline"
          :rules="rules"
          ref="formInlinezin"
        >
          <el-row>
            <el-col :span="24" style="margin-left:20px">
              <el-form-item label="手机号" prop="mobileNo" style="margin-top:16px">
                <el-input v-model="formInlinezin.mobileNo" clearable maxlength="11"></el-input>
              </el-form-item>
              <el-form-item label="验证码" prop="smsValidCode">
                <el-input
                  v-model="formInlinezin.smsValidCode"
                  clearable
                  style="width:120px;margin-right:5px;"
                ></el-input>
                <div v-show="showzin" class="verification">
                  <span @click="getCode" style="cursor:pointer;">{{code}}</span>
                </div>
                <div
                  v-show="showzin!=true"
                  class="verification"
                  style="background-color:#bfbcbc;color:#fff;"
                >
                  <span>{{count}}秒</span>
                </div>
              </el-form-item>
              <el-form-item label="新密码" prop="newPwd">
                <el-input
                  type="password"
                  v-model="formInlinezin.newPwd"
                  clearable
                  maxlength="20"
                  placeholder="8-20位,支持数字和字母"
                ></el-input>
              </el-form-item>
              <el-form-item label="确认密码" prop="newConfirmPwd">
                <el-input
                  type="password"
                  v-model="formInlinezin.newConfirmPwd "
                  clearable
                  maxlength="20"
                  placeholder="8-20位,支持数字和字母"
                ></el-input>
              </el-form-item>
              <el-form-item style="width:100%;text-align:center">
                <el-button type="primary" @click="submitForm('formInlinezin')">确认</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "../httpjs.js";
import { baseurl } from "../base.js";
import { mapMutations } from "vuex";
export default {
  created() {
    if (localStorage.getItem("tokenId") !== "") {
      this.$http.post("/w/user/logout").then(
        () => {
          axios.defaults.headers.post["tokenId"] = "";
          localStorage.setItem("tokenId", "");
        },
        e => {
          axios.defaults.headers.post["tokenId"] = "";
          localStorage.setItem("tokenId", "");
        }
      );
    }

    this.vaite = baseurl + "/validPic?v=" + new Date().getTime();
    this.formLabelAlign.loginId = !!localStorage.getItem("loginUser")
      ? localStorage.getItem("loginUser")
      : "";
  },
  data() {
    var validatePass3 = (rule, value, callback) => {
      let rez = /^(?![^A-z]+$)(?!\D+$)[A-z\d]{8,20}$/;
      if (!rez.test(value)) {
        return callback(new Error("8-20位,支持数字和字母"));
      }
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.formInlinezin.newConfirmPwd !== "") {
          this.$refs.formInlinezin.validateField("newConfirmPwd");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formInlinezin.newPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      let rez = /^1[0-9]{10}$/;
      if (!rez.test(value)) {
        return callback(new Error("请输入正确的手机号"));
      }
      return callback();
    };
    return {
      show: true,
      showzin: true,
      count: "",
      timer: null,
      code: "发送验证码",
      vaite: "",
      password: "password",
      fullscreenLoading: false,
      labelPosition: "left",
      title: "",
      captcha: "",
      left: "left",
      formLabelAlign: {
        loginId: "",
        loginPwd: ""
      },
      datazin: {},
      changepass: false,
      formInlinezin: {
        mobileNo: "",
        smsValidCode: "",
        newConfirmPwd: "",
        newPwd: ""
      },
      rules: {
        smsValidCode: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ],
        mobileNo: [
          {
            required: true,
            message: "请填写手机号",
            trigger: "blur"
          },
          { validator: validatePass, trigger: "blur" }
        ],
        newPwd: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          },
          { validator: validatePass3, trigger: "blur" },
          {
            min: 8,
            max: 20,
            message: "8-20位,支持数字和字母",
            trigger: "blur"
          }
        ],
        newConfirmPwd: [
          {
            required: true,
            message: "请确认密码",
            trigger: "blur"
          },
          { validator: validatePass2, trigger: "blur" },
          {
            min: 8,
            max: 20,
            message: "8-20位,支持数字和字母",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    forgotpass() {
      this.changepass = true;
      this.showzin = true;
      for (let i in this.formInlinezin) {
        this.formInlinezin[i] = "";
      }
      this.$nextTick(e => {
        this.$refs["formInlinezin"].resetFields();
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          axios.defaults.headers.post["tokenId"] = "";
          this.fullscreenLoading = true;
          this.$http
            .post("/w/user/modifyPwdByMobile", {
              ...this.formInlinezin
            })
            .then(
              data => {
                this.$message.success("找回密码成功");
                this.changepass = false;
                this.fullscreenLoading = false;
                this.$refs["formInlinezin"] &&
                  this.$refs["formInlinezin"].resetFields();
              },
              () => {
                this.fullscreenLoading = false;
              }
            );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getCode() {
      if (this.formInlinezin.mobileNo == "") {
        this.$message.error("请填写手机号");
      } else if (!/^1[0-9]\d{9}$/.test(this.formInlinezin.mobileNo)) {
        this.$message.error("请填写正确的手机号");
        return false;
      } else {
        axios.defaults.headers.post["tokenId"] = "";
        this.$http
          .post(`/w/sms/sendValidCode`, {
            mobileNo: this.formInlinezin.mobileNo
          })
          .then(data => {
            this.fullscreenLoading = false;
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.showzin = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.showzin = true;
                  this.code = "重新发送";
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          })
          .catch(error => {
            this.fullscreenLoading = false;
          });
      }
    },
    ...mapMutations({
      init: "initdata",
      labelAdminInit: "labelAdminInit"
    }),
    togg() {
      this.show = !this.show;
      this.password = this.password == "password" ? "text" : "password";
    },
    login() {
      if (!this.formLabelAlign.loginId) {
        this.$message({
          type: "error",
          message: "请填写账号"
        });
        return false;
      }
      if (!this.formLabelAlign.loginPwd) {
        this.$message({
          type: "error",
          message: "请填写密码"
        });
        return false;
      }
      this.fullscreenLoading = true;
      this.$http
        .post("/user/login?captcha=" + this.captcha, this.formLabelAlign)
        .then(data => {
          this.labelAdminInit();
          data = data.data;
          axios.defaults.headers.post["tokenId"] = data.tokenId;
          axios.defaults.headers.get["tokenId"] = data.tokenId;
          this.$router.push("/");
          localStorage.setItem("tokenId", data.tokenId);
          localStorage.setItem("isFirstLogin", data.isFirstLogin);
          localStorage.setItem("mobileNo", data.mobileNo);
          localStorage.setItem("loginUser", this.formLabelAlign.loginId);
          localStorage.setItem("loginPwd", this.formLabelAlign.loginPwd);
          localStorage.setItem("menu", JSON.stringify(data.menuMapList));
          localStorage.setItem("dictionary", JSON.stringify(data.dictionary));
          localStorage.setItem("username", data.userName);
          localStorage.setItem("isPayBefore", data.isPayBefore);
          localStorage.setItem("isPayBefore", data.isPayBefore);
          localStorage.setItem("platCode", data.platCode);
          localStorage.setItem("merId", data.merId);
        })
        .catch(error => {
          this.clickVaite();
          this.fullscreenLoading = false;
        });
    },
    clickVaite() {
      this.vaite = baseurl + "/validPic?v=" + new Date().getTime();
    }
  }
};
</script>

<style scoped>
.verification {
  width: 80px;
  height: 30px;
  background: #409eff;
  font-size: 12px;
  border-radius: 3px;
  line-height: 30px;
  text-align: center;
  color: white;
  display: inline-block;
}
.inp {
  padding: 18px 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eeeeee;
}
.inp > div:nth-child(1) {
  width: 22px;
}
.inp > div:nth-child(2) {
  flex: 1;
}
.inp > div:nth-child(3) {
  width: 35px;
  text-align: right;
}
.top {
  text-align: center;
}
.app {
  width: 350px;
  padding: 20px 50px;
}
.bodd {
  background-color: #fff;
  border-radius: 5px;
  position: relative;
  overflow: hidden;
}
.centen {
  text-align: center;
  font-size: 27px;
  font-weight: bold;
  margin-bottom: 20px;
}
.action {
  display: flex;
  height: 30px;
  justify-content: flex-end;
  align-items: center;
  padding-top: 10px;
}
.action span {
  color: #409eff;
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/view/login.vue